DoohApps.factory('externalDoohApi', ['MediaAssetsBLL', 'modal2', '$location', 'DialogHandler','User', function (MediaAssetsBLL, modal2, $location, DialogHandler,User) {
    // server side hot loader, communicating with api-v.2.0.js
    var getHostname = function (url) {
        var match = url.match(/:\/\/(www[0-9]?\.)?(.[^\/:]+){1}(:\d+)?/i);
        if (match != null && match.length > 2 && typeof match[0] === 'string' && match[0].length > 0) {
            return $location.protocol() + match[0];
        }
    }

    var nestedModal, assetsSavedCallback, campaignSavedCallback, onFullscreen, campaign, origin, iframe, scope, modal;
    var factoryObj = {
        //call this method after iframe has been loaded
        init: function (_campaign, _origin, _scope, _modal) {
            campaign = _campaign;
            scope = _scope;
            modal = _modal
            origin = getHostname(_origin);
            iframe = document.getElementById('configFrame');
            factoryObj.autoSaveEnabled = scope.SelectedApplication.AutoSave;
            factoryObj.campaignSaveCallbackSet = false;

            nestedModal = document.getElementsByClassName('nestedModal-dialog')[0];
            
            factoryObj.openAssetSelector = function (filter) {
                filter = filter || {};
                var modalObj = {
                    name: 'MediaAssetSelector',
                    windowClass: 'assetPopup nestedModal',
                    resolvedCallback: function (assets) {
                        assets = assets.map(function (asset) {
                            return {
                                MediaAssetID: asset.MediaAssetID,
                                Title: (asset.Title) ? asset.Title : asset.AssetTitle,
                                AssetType: asset.AssetType,
                                IconURL: asset.IconUrl,
                                FileURL: asset.FileURL,
                                FileDuration: asset.FileDuration,
                                FileSize: asset.FileSize,
                                FileExtension: asset.FileExtension,
                                Resolution: asset.Resolution,
                                DurationInSeconds: asset.DurationInSeconds

                            }
                        });
                        if (factoryObj.autoSaveEnabled) {
                            if (factoryObj.campaignSaveCallbackSet)
                                factoryObj.saveCampaignFired(function (data) {
                                    factoryObj.saveAssetsFinished(data);
                                }, campaign, assets);
                            else
                                DialogHandler.AddError('Asset saving not configured');
                        }
                        else
                            iframe.contentWindow.postMessage({ action: 'setMediaAssets', data: assets }, origin);
                    },
                    passObj: filter
                }
                modal2.open(modalObj);
            };

            factoryObj.parseDateTimeResult = function (time, date) {
                var momentDate = new moment(date);
                var momentTime = new moment(time, 'HH:mm');

                var ret = new Date(momentDate.valueOf());

                ret.setHours(momentTime.hours());
                ret.setMinutes(momentTime.minutes());
                ret.setSeconds(0);
                ret.setMilliseconds(0);

                return ret;
            }

            scope.daterangeSelectorSetDates = function () {
                var result = {};

                result.StartDateTime = factoryObj.parseDateTimeResult(scope.dateRange.DefaultStartTime, scope.dateRange.StartDate);
                result.EndDateTime = factoryObj.parseDateTimeResult(scope.dateRange.DefaultEndTime, scope.dateRange.EndDate);

                iframe.contentWindow.postMessage({ action: 'setSelectedDates', data: result }, origin);
            }

            factoryObj.openDaterangeSelector = function (existingDates) {
                scope.dateRange = {};

                scope.dateRange.CampaignTitle = (existingDates && existingDates.CampaignTitle) ? existingDates.CampaignTitle : '';

                var now = new Date();
                now.setMinutes(0,0);
                scope.dateRange.StartDate = (existingDates && existingDates.StartDateTime) ? existingDates.StartDateTime : new Date(now.getTime());

                now.setHours(now.getHours() + 2);
                scope.dateRange.EndDate = (existingDates && existingDates.EndDateTime) ? existingDates.EndDateTime : now;

                scope.dateRange.StartTime = moment(scope.dateRange.StartDate).format('HH:mm');
                scope.dateRange.EndTime = moment(scope.dateRange.EndDate).format('HH:mm');

                scope.dateRange.DefaultStartTime = moment(scope.dateRange.StartDate).format('HH:mm');
                scope.dateRange.DefaultEndTime = moment(scope.dateRange.EndDate).format('HH:mm');

                modal.open('DaterangeSelector', 'serviceAppRequestModal');
            };

            factoryObj.openCampaignSelector = function (filter) {
                filter = filter || {};
                var modalObj = {
                    name: 'CampaignSelector',
                    windowClass: 'assetPopup nestedModal',
                    resolvedCallback: function (campaigns) {
                        campaigns = campaigns.map(function (campaign) {
                            return campaign;
                        });
                        iframe.contentWindow.postMessage({ action: 'setCampaignItems', data: campaigns }, origin);
                    },
                    passObj: filter
                }
                modal2.open(modalObj);
            };

            factoryObj.saveCampaignAssets = function (dataToSave) {
                var assetIDs = [];
                var linkedCampaignsIDs = [];
                var externalConfiguration = '';

                try { var assetData = ('assets' in dataToSave) ? dataToSave.assets : dataToSave; assetIDs = assetData.map(function (asset) { return asset.MediaAssetID }) } catch (e) { void 0; } // we both support dataToSave of dataToSave.assets as source
                try { linkedCampaignsIDs = dataToSave.linkedCampaigns.map(function (campaign) { return campaign.CampaignID }) } catch (e) { void 0; }
                try { externalConfiguration = dataToSave.externalConfiguration; } catch (e) { void 0; } 


                MediaAssetsBLL.saveExternalCampaign(function (data) {
                    if (assetsSavedCallback != null)
                        assetsSavedCallback(data);
                }, campaign, assetIDs, linkedCampaignsIDs, externalConfiguration);
            };

            factoryObj.saveCampaignFired = function (callback, _campaign, assets) {
                assets = assets || [];
                campaign = _campaign;
                assetsSavedCallback = callback;
                iframe.contentWindow.postMessage({ action: 'saveCampaignFired', data: assets }, origin);
            };

            factoryObj.saveAssetsFinished = function (data) {
                var response = {
                    status: data.Status,
                    error: data.hasError ? true : false,
                    errorMsg: (data.errors != undefined && data.errors.length > 0) ? data.errors[0] : '',
                    data: data.Data != undefined ? data.Data.Content != undefined ? data.Data.Content : null : null
                };
                
                iframe.contentWindow.postMessage({ action: 'saveAssetsFinished', data: response }, origin);
            };

            factoryObj.onCampaignSaved = function (callback) {
                campaignSavedCallback = callback;
            }

            factoryObj.campaignSaved = function () {
                if (campaignSavedCallback != null)
                    campaignSavedCallback();
            }

            factoryObj.onFullscreen = function (callback) {
                onFullscreen = callback;
            }

            factoryObj.goFullscreen = function () {
                //Because it's possible that iframe size was set by jquery before in updateIframeSize funtion,
                //we have to use it here as well. We can do some things with ng-class, but those rules
                //will have lower priority. Also, there is no way to set ng-class for modal outer container.
                var done = false;
                angular.element('.configuratorModal .modal-dialog').height('100%');
                //for some reason width('100%') doesn't work here.
                $(nestedModal).css({
                    maxWidth: $(nestedModal).parent().width()
                });
                $(iframe).height('100%');
                var resizeFinished = function () {
                    done = true;
                    nestedModal.removeEventListener('webkitTransitionEnd', resizeFinished, false);
                    nestedModal.removeEventListener('transitionend', resizeFinished, false);
                    nestedModal.removeEventListener('msTransitionEnd', resizeFinished, false);
                    nestedModal.removeEventListener('oTransitionEnd', resizeFinished, false);
                    iframe.contentWindow.postMessage({ action: 'fullscreenFinished' }, origin);
                }

                nestedModal.addEventListener('webkitTransitionEnd', resizeFinished, false);
                nestedModal.addEventListener('transitionend', resizeFinished, false);
                nestedModal.addEventListener('msTransitionEnd', resizeFinished, false);
                nestedModal.addEventListener('oTransitionEnd', resizeFinished, false);

                //It is said that sometimes eventListener for transition end doesn't fire. So here is this.
                //It also never fired for EDGE.
                setTimeout(function () {
                    if (!done) {
                        resizeFinished();
                    }
                }, 525);

                if (onFullscreen != null)
                    onFullscreen();
            }

            factoryObj.updateIframeSize = function (dim) {
                //resize modal width according to desired iframe's width + padding
                $(nestedModal).css({
                    maxWidth: dim.width + ($(nestedModal).outerWidth() - $(nestedModal).width())
                });
                angular.element('#configFrame').width(dim.width);
                angular.element('#configFrame').height(dim.height);
            }

            var user = JSON.parse(JSON.stringify(User));
            iframe.contentWindow.postMessage({ action: 'initialized', data: { campaign: campaign, user: user, origin: window.location.origin, autoSaveEnabled: factoryObj.autoSaveEnabled } }, origin);
        }
    }

    function msgListener(msg) {
        switch (msg.data.action) {
            case 'goFullscreen':
                factoryObj.goFullscreen();
                break;
            case 'updateIframeSize':
                factoryObj.updateIframeSize(msg.data.data);
                break;
            case 'campaignAssets':
                //external api has sent list of assets
                factoryObj.saveCampaignAssets(msg.data.data);
                break;
            case 'openAssetSelector':
                factoryObj.openAssetSelector(msg.data.data);
                break;
            case 'openCampaignSelector':
                factoryObj.openCampaignSelector(msg.data.data);
                break;
            case 'openDaterangeSelector':
                factoryObj.openDaterangeSelector(msg.data.data);
                break;
            case 'saveCallbackSet':
                factoryObj.campaignSaveCallbackSet = true;
                break;
            case 'campaignSaved':
                factoryObj.campaignSaved();
                break;
            default: break;
        }
    }

    window.addEventListener('message', msgListener, false);

    return factoryObj;
}]);